import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '../../util_grid/grid.js';
import Link from '../../base_link/component';
import { ProductImage } from 'audamatic-ui';
import SectionHeader from '../../base_section-header/component';
import Text from '@text';
import { t } from '@utils/i18n';
import './styles/styles.scss';
/**
 * Product-details component
 *
 */
class ProductDetails extends Component {
  get product() {
    return this.props.product;
  }

  get supplierType() {
    const { catalog } = this.product;
    const map = {
      Muziek: 'comp.bookdetails.publisher.music',
      Film: 'comp.bookdetails.publisher.movies',
      Games: 'comp.bookdetails.publisher.games',
      Kantoor: 'comp.bookdetails.publisher.office',
      'Spel & Speelgoed': 'comp.bookdetails.publisher.toys',
      default: 'comp.bookdetails.publisher',
    };
    return t(map[catalog] || map.default);
  }


  get productPartUnits() {
    const { type } = this.product;
    const CDTypes = [
      'Blu-Ray',
      'CD+DVD',
      'Luisterboek',
      'Microsoft XBox One',
      '3D Blu-Ray',
      'Sony PlayStation 3',
      'Microsoft XBox 360',
      'DVD',
      '4K Blu-Ray',
      'DVD+CD',
      'Sony PlayStation 4',
      'CD',
      'Nintendo Wii U',
      'Nintendo Wii',
      'PC CD-DVD',
    ];
    const key = CDTypes.includes(type) ? 'comp.bookdetails.numberofcds' : 'comp.bookdetails.numberofparts';
    return t(key);
  }

  renderPersons() {
    return this.product.persons.map((person, index) => <Fragment key={person.url}>
      {!!index && ', '}
      <Link className="person" href={person.url}>{person.name}</Link>
    </Fragment>);
  }

  render() {
    const { isBook, ean, sku } = this.product || {};

    if (!this.product) {
      return null;
    }
    return (
      <div className="pdp-details">
        <div className="container">
          <SectionHeader
            title={t('pdp.menu.panel.details')}
          />
          <Row>
            <Col sm={2} className="hidden-xs">
              <div className="image wrapper">
                <ProductImage
                  product={this.product}
                  maxHeight={149}
                />
              </div>
            </Col>
            <Col sm={10}>
              <div className="row details-list" data-test-id="pdp-details-list">
                <Col xs={12}>
                  <ul className="list-unstyled">
                    {this.product.persons.length !== 0 && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.authors</Text> : {this.renderPersons()}
                        </span>
                      </li>
                    ) }
                    {this.product.brand && (
                      <li className="col-sm-6">
                        <span>
                          {this.supplierType}: <Link className="brand" href={this.product.brandUrl}>{this.product.brand}</Link>
                        </span>
                      </li>
                    )}
                    <li className="col-sm-6">
                      <span>
                        <Text>{isBook ? 'comp.bookdetails.isbn' : 'comp.bookdetails.ean'}</Text> : {ean || sku}
                      </span>
                    </li>
                    {this.product.getProductLanguages() && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.language</Text> : {this.product.getProductLanguages() }
                        </span>
                      </li>
                    ) }
                    {this.product.type && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.version</Text> : {this.product.type}
                        </span>
                      </li>
                    ) }
                    {this.product.pages && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.pages</Text> : {this.product.pages}
                        </span>
                      </li>
                    ) }
                    {this.product.getReleaseMJDate() && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.appearance</Text> : {this.product.getReleaseMJDate()}
                        </span>
                      </li>
                    ) }
                    {this.product.sizes && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.sizes</Text> : {this.product.sizes}
                        </span>
                      </li>
                    ) }
                    {this.product.weight && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.weigth</Text> : {this.product.weight}
                        </span>
                      </li>
                    ) }
                    {this.product.getProductDimensions() && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.sizes</Text> : {this.product.getProductDimensions()}
                        </span>
                      </li>
                    ) }
                    {this.product.series && this.product.series.length > 0 && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.serie</Text> : {this.product.getProductSeries()}
                        </span>
                      </li>
                    ) }
                    {this.product.numberofparts && (
                      <li className="col-sm-6">
                        <span>
                          {this.productPartUnits} : {this.product.numberofparts}
                        </span>
                      </li>
                    ) }
                    {this.product.parentaladvisory && this.product.parentaladvisory.length > 0 && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.parentaladvisory</Text> : {this.product.getParentaladvisory()}
                        </span>
                      </li>
                    )}
                    {this.product.duration && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.duration</Text> : {this.product.formatedDuration}
                        </span>
                      </li>
                    )}
                    {this.product.subtitles && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.subtitles</Text> : {this.product.getProductSubtitles()}
                        </span>
                      </li>
                    )}
                    {this.product.getProductFormat() && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.formaat</Text> : {this.product.getProductFormat()}
                        </span>
                      </li>
                    )}
                    {/* TODO: Don't show trackdata untill data provided by BE is valid */}
                    {/* {this.product.trackdata && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.trackdata</Text> : {this.product.trackdata}
                        </span>
                      </li>
                    )} */}
                    {this.product.getProductAwards() && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.awards</Text> : {this.product.getProductAwards()}
                        </span>
                      </li>
                    )}
                    {this.product.screenFormat && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.screenformat</Text> : {this.product.screenFormat}
                        </span>
                      </li>
                    )}
                    {this.product.soundFormat && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.soundformat</Text> : {this.product.soundFormat}
                        </span>
                      </li>
                    )}
                    {this.product.regionCode && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.regioncode</Text> : {this.product.regionCode}
                        </span>
                      </li>
                    )}
                    {this.product.editionType && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.editiontype</Text> : {this.product.editionType}
                        </span>
                      </li>
                    )}
                    {this.product.getProductThemas() && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.thema</Text> : {this.product.getProductThemas()}
                        </span>
                      </li>
                    )}
                    {this.product.extraFeatures && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.extrafeatures</Text> : {this.product.extraFeatures}
                        </span>
                      </li>
                    )}
                    {this.product.aviLevel && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.avilevel</Text> : {this.product.aviLevel}
                        </span>
                      </li>
                    )}
                    {this.product.ageRating && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.agerating</Text> : {this.product.ageRating}
                        </span>
                      </li>
                    )}
                    {this.product.getProductKeywords() && (
                      <li className="col-sm-6">
                        <span>
                          <Text>comp.bookdetails.keywords</Text> : {this.product.getProductKeywords()}
                        </span>
                      </li>
                    )}
                  </ul>
                </Col>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

ProductDetails.propTypes = {
  /**
   * The product object
   */
  product: PropTypes.object,
};

export default ProductDetails;
